/**
 * Pure H OS · Phase D Wave 4 · Unit Economics (types + live view).
 * MongoDB collection: `pureh_unit_economics`.
 */
import { liveArray } from "../services/store";

export type UnitEconomicsRow = {
  id: string;
  sku: string;
  name: string;
  revenuePerUnit: number;
  cogs: number;
  grossProfit: number;
  marginPct: number;
  adSpendPerUnit: number;
  cac: number;
  cltv: number;
  contributionMargin: number;
};

export const UNIT_ECONOMICS: UnitEconomicsRow[] = liveArray<UnitEconomicsRow>("unit_economics");
